export const EndorsementFirearmRenewalConstants = {
    NEW_FIREARM: '00000000-0000-0000-0000-000000000000',
};